export enum StackPath {
    Foundations = "foundations",
    Customer = "customer",
    Brand = "brand",
    Product = "product",
    Membership = "membership",
    Experience = "experience",
    Content = "content",
    Comms = "comms",
    Operations = "operations",
    Growth = "Growth",
    Sales = "sales",
    Partnerships = "partnerships",
    Hr = "hr",
    Sponsorships = "sponsorships",
    Events = "events",
    Designer = "designer",
    Education = "education",
    Startup = "startup",
    Farm = "farm",
    Ecomm = "ecomm",
    Travel = "travel",
    Consulting = "consulting",
    Architect = "architect",
    Wine = "wine",
    Beverage = "beverage",
    Accommodation = "accommodation",
    SelfStorage = "self-storage",
    Restaurant = "restaurant",
    RealEstate = "real-estate",
    Dentist = "dentist",
    Doctor = "doctor",
    Charity = "charity",
    Agency = "agency",
    Construction = "construction",
    Fund = "fund",
    Manufacturing = "manufacturing",
    Coach = "coach",
    SportsTeam = "sports-team",
    PersonalTrainer = "personal-trainer",
    Gym = "gym",
    Athlete = "athlete",
    ClimbingGym = "climbing-gym",
    GolfClub = "golf-club",
    LandManagement = "land-management",
    Retail = "retail",
    Research = "research",
    BuildingManagement = "Building-Management",
    Lawyer = "lawyer"
}

export const stackPathName = {
    [StackPath.Foundations]: "Foundations",
    [StackPath.Customer]: "Customer",
    [StackPath.Brand]: "Brand",
    [StackPath.Product]: "Product",
    [StackPath.Membership]: "Membership",
    [StackPath.Experience]: "Experience",
    [StackPath.Content]: "Content",
    [StackPath.Comms]: "Advertising",
    [StackPath.Operations]: "Operations",
    [StackPath.Growth]: "Growth",
    [StackPath.Sales]: "Sales",
    [StackPath.Partnerships]: "Partnerships",
    [StackPath.Hr]: "Recruiting",
    [StackPath.Sponsorships]: "Sponsorships",
    [StackPath.Events]: "Events",
    [StackPath.Designer]: "Designer",
    [StackPath.Education]: "Education",
    [StackPath.Startup]: "Startup",
    [StackPath.Farm]: "Farm",
    [StackPath.Ecomm]: "Ecomm",
    [StackPath.Travel]: "Travel",
    [StackPath.Consulting]: "Consulting",
    [StackPath.Architect]: "Architecture",
    [StackPath.Wine]: "Wine",
    [StackPath.Beverage]: "Beverage",
    [StackPath.Accommodation]: "Accommodation",
    [StackPath.SelfStorage]: "Self Storage",
    [StackPath.Restaurant]: "Restaurant",
    [StackPath.RealEstate]: "Real Estate",
    [StackPath.Dentist]: "Dentist",
    [StackPath.Doctor]: "Doctor",
    [StackPath.Charity]: "Charity",
    [StackPath.Agency]: "Agency",
    [StackPath.Construction]: "Construction",
    [StackPath.Fund]: "Fund",
    [StackPath.Manufacturing]: "Manufacturing",
    [StackPath.Coach]: "Coach",
    [StackPath.SportsTeam]: "Sports Team",
    [StackPath.PersonalTrainer]: "Personal Trainer",
    [StackPath.Gym]: "Gym",
    [StackPath.Athlete]: "Athlete",
    [StackPath.ClimbingGym]: "Climbing Gym",
    [StackPath.GolfClub]: "Golf Club",
    [StackPath.LandManagement]: "Land Management",
    [StackPath.Retail]: "Retail",
    [StackPath.Research]: "Research",
    [StackPath.BuildingManagement]: "Building Management",
    [StackPath.Lawyer]: "Lawyer",
    } as const
;
